// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3F5_E","col":"styles_col__O9Xhy","actions":"styles_actions__oelPp","conflict":"styles_conflict__2IFT0"};